import Keycloak from "keycloak-js";
import React from "react";
import ReactDOM from "react-dom";
import { NavbarAuthLoading } from "./components/organisms/mainheader/NavbarAuthLoading";
import { SmartmanApp } from "./SmartmanApp";
import "./styles/main.scss";

const rootElement = document.getElementById("root");

/**
 * Full-page status while Keycloak-js runs or on failure (no silent blank screen).
 * ASSUMPTION: Final users should not see technical error payloads.
 */
const KeycloakBootstrapScreen = ({ variant, title, message }) => (
  <div className="auth-bootstrap">
    {variant === "loading" && <NavbarAuthLoading />}
    <div className="auth-bootstrap__content">
      {variant === "loading" && (
        <p className="auth-bootstrap__message">Connecting to Smartman Auth</p>
      )}
      {variant === "error" && (
        <>
          <h1 className="auth-bootstrap__error-title">{title}</h1>
          <p className="auth-bootstrap__error-message">{message}</p>
        </>
      )}
    </div>
  </div>
);

let keycloak = Keycloak("/keycloak.json");

ReactDOM.render(
  <KeycloakBootstrapScreen variant="loading" />,
  rootElement
);

keycloak
  .init({ onLoad: "login-required" })
  .then((authenticated) => {
    if (!authenticated) {
      window.location.reload();
      return;
    }

    keycloak
      .loadUserInfo()
      .then((userInfo) => {
        sessionStorage.setItem("authentication", keycloak.token);
        sessionStorage.setItem("refreshToken", keycloak.refreshToken);
        ReactDOM.render(
          <SmartmanApp userInfo={userInfo} keycloak={keycloak} />,
          rootElement
        );

        setTimeout(() => {
          keycloak
            .updateToken(70)
            .then((refreshed) => {
              if (refreshed) {
                console.debug("Token refreshed" + refreshed);
              } else {
                console.warn(
                  "Token not refreshed, valid for " +
                    Math.round(
                      keycloak.tokenParsed.exp +
                        keycloak.timeSkew -
                        new Date().getTime() / 1000
                    ) +
                    " seconds"
                );
              }
            })
            .catch((error) => {
              console.error("Keycloak updateToken failed", error);
            });
        }, 120000);
      })
      .catch((err) => {
        console.error("Keycloak loadUserInfo failed", err);
        ReactDOM.render(
          <KeycloakBootstrapScreen
            variant="error"
            title="Something went wrong"
            message="We could not load your account. Please try again later or contact support."
          />,
          rootElement
        );
      });
  })
  .catch((err) => {
    console.error("Keycloak init failed", err);
    ReactDOM.render(
      <KeycloakBootstrapScreen
        variant="error"
        title="Sign-in unavailable"
        message="We could not connect to the login service. Please try again later or contact support."
      />,
      rootElement
    );
  });
